exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#root img {\n  max-width: 100%;\n  display: block;\n  margin: 1rem auto; }\n\n#root a {\n  color: #9797ff; }\n\n.img-big {\n  transform: scale(1.3); }\n", ""]);

// exports
